export default __webpack_public_path__ + "img/3c4d8547480588a2667e4f66f415f025.png";